const SvgSecurity2 = (props) => (
  <>
    <path
      d="M96 32c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64Zm0 96.28c-17.83 0-32.28-14.45-32.28-32.28S78.17 63.72 96 63.72 128.28 78.17 128.28 96 113.83 128.28 96 128.28Z"
      fill={props.p20}
    />
    <g fill="none" stroke={props.p30} strokeMiterlimit={10}>
      <path d="M104 96c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8Z" />
      <path d="M192 96c0 53.02-42.98 96-96 96S0 149.02 0 96 42.98 0 96 0c26.49 0 50.47 10.73 67.84 28.07m-62.22 62.15 88.01-87.56" />
    </g>
    <circle cx={192} r={4} fill={props.p30} />
  </>
);

export default SvgSecurity2;
